// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FormattedAddress__address {\n  display: flex;\n  -moz-column-gap: 2px;\n       column-gap: 2px;\n}\n\n.FormattedAddress__underline {\n  text-decoration-line: underline;\n}\n", "",{"version":3,"sources":["webpack://./src/brands/ShopPromiseBrand/components/FormattedAddress/FormattedAddress.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAe;OAAf,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":[".address {\n  display: flex;\n  column-gap: 2px;\n}\n\n.underline {\n  text-decoration-line: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"address": "FormattedAddress__address",
	"underline": "FormattedAddress__underline"
};
export default ___CSS_LOADER_EXPORT___;
